import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { GlobalMessageService, GlobalMessageType, RoutingService, TranslationService, I18nModule } from '@spartacus/core';
import { CustomFormValidators, FormErrorsComponent } from '@spartacus/storefront';
import { ModalConfig } from 'src/app/core/model/modal.config-model';
import { CustomProfileService } from 'src/app/core/services/custom-profile.service';
import { ToastService } from 'src/app/core/services/toaster.service';
// import { CommonconfirmpopupComponent } from '../../commonconfirmpopup/commonconfirmpopup.component';
import { CommonconfirmpopupComponent } from 'src/app/modules/commonconfirmpopup/commonconfirmpopup.component';
import { CommonPageBreadcrumbsComponent } from '../../../shared/components/common-page-breadcrumbs/common-page-breadcrumbs.component';

@Component({
    selector: 'app-custom-forgot-password',
    templateUrl: './custom-forgot-password.component.html',
    styleUrls: ['./custom-forgot-password.component.scss'],
    imports: [CommonPageBreadcrumbsComponent, FormsModule, ReactiveFormsModule, FormErrorsComponent, I18nModule]
})
export class CustomForgotPasswordComponent implements OnInit {
  forgetPasswordForm: UntypedFormGroup;
  data: any;
  mailSent = true;
  error: any;
  title: any;
  navigationData: any;
  showError = false;
  constructor(protected fb: UntypedFormBuilder , private routingService: RoutingService, private router: Router,
              private translation: TranslationService,
              private customProfileService: CustomProfileService ,
              private cd: ChangeDetectorRef, private toastService: ToastService, 
              protected  globalMessageService: GlobalMessageService,
              private modalService:NgbModal) { }

  ngOnInit(): void {
    this.translation.translate('home.toastErrorMessages.something').subscribe(res => {
      this.error = res;
    });
    this.translation.translate('breadcrumb.forgotpassword').subscribe(res => {
      this.title = res;
    });
    this.translation.translate('breadcrumb.forgotpassword.breadcrumb').subscribe(res => {
      this.navigationData = res;
    });
    this.translation.translate('home.toastErrorMessages.something').subscribe(res => {
      this.error = res;
    });
    this.forgetPasswordForm = this.fb.group({
      email: ['', [Validators.required, CustomFormValidators.emailValidator]],
      alternate:[false]
    });
  }

  backToLogin(): void{
    this.routingService.go({
      cxRoute: 'login',
    });
  }

  submit(): any{
    this.showError = false;
    const { email } = this.forgetPasswordForm.controls;
    this.cd.detectChanges();
    console.log(this.forgetPasswordForm.value);
    const preference = this.forgetPasswordForm.value.alternate==false?'DEFAULT':'ALT'
    this.customProfileService.forgotPassword(email.value,preference).subscribe(
      data => {
        if (data) {
          if (data.success || data.error) {
            if (data.success) {
              this.showError = false;
              this.toastService.show(data.success);
              this.router.navigate(['login']);
            } else if (data.error) {
              this.showError = true;
              this.globalMessageService.add(
                data.error,
                GlobalMessageType.MSG_TYPE_ERROR,
              );
            }
          } else {
            this.showError = true;
            this.toastService.show(this.error);
          }
        }
        else{
            this.toastService.show('Empty response received, please contact support team(未收到回复，请联系支持团队。)');
        }
       
      }
    );
  }
  openpopup(){
    const ModalRef = this.modalService.open(CommonconfirmpopupComponent, {
      centered: true,
      size: 'lg',
    });
    ModalRef.componentInstance.from = 'forgotpassword';

  }
}
